import * as React from 'react';
import * as _ from 'lodash';
import { Dispatch, connect } from 'react-redux';
import { AppActionCreators, IApplicationState, ReportActionCreators } from '@nkr/store/index';
import { ICenter, ICenterListResponse } from '@nkr/models/index';
import { FileDocumentType } from '@nkr/enums/document-type';
import { downloadFile } from '@nkr/services/download-file';
import Grid from './grid';

interface IOwnProps {
    isCenterLogin: boolean,
    centerId: number
}

interface IStateProps { }

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getCenterComplianceList: () => Promise<ICenterListResponse>,
    downloadFile: (docType: number, lookupId: number) => Promise<any>
}

type TProps = IStateProps & IDispatchProps & IOwnProps

interface IState {
    data: ICenter[],
    centerId: number
}

class Compliance extends React.Component<TProps, IState> {
    readonly state: IState = {
        data: [],
        centerId: 0
    }

    componentDidMount = () => {
        this.getData();
    }

    getData = () => {
        this.props.showLoading('Getting compliance report, one moment please...').then(() => {
            this.props.getCenterComplianceList().then(response => {
                if (response.data.success) {
                    this.setState({
                        data: response.data.results
                    });
                }
            }).finally(() => {
                this.props.hideLoading();
            });
        });
    }

    handleDownloadFile = (docType: FileDocumentType, centerId: number) => {
        let center = this.state.data.find(x => x.id == centerId);
        let fileName = '';

        this.props.downloadFile(docType, centerId).then((response: any) => {
            switch (docType) {
                case FileDocumentType.RecipientCenterAgreement:
                    fileName = center.alias.toLowerCase() + `recippdf`
                    break;
                case FileDocumentType.DonorCenterAgreement:
                    fileName = center.alias.toLowerCase() + `donorpdf`
                    break;

                case FileDocumentType.CmsGoodStanding:
                    fileName = center.alias.toLowerCase() + `_cms`
                    break;

                default:
                    break;
            }

            downloadFile(response.data, fileName, response.data.type);
        });
    }

    render = () => {
        return (
            <>
                <Grid data={this.state.data} onDownloadFile={this.handleDownloadFile} />
            </>
        );
    }
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
        reports: appState.reports
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getCenterComplianceList: () => {
            return dispatch(ReportActionCreators.getCenterComplianceList());
        },
        downloadFile: (docType, centerId) => {
            return dispatch(ReportActionCreators.downloadComplianceFile(docType, centerId));
        }
    };
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(Compliance);